import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const LegalPage = () => {
  const { pageType } = useParams();
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    loadContent();
  }, [pageType]);

  const loadContent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/legal/${pageType}`);
      const data = await response.json();
      
      if (data.success) {
        setContent(data.page.content);
      }
      
      // Set title
      const titles = {
        'impressum': 'Impressum',
        'agb': 'Allgemeine Geschäftsbedingungen',
        'datenschutz': 'Datenschutzerklärung'
      };
      setPageTitle(titles[pageType] || 'Rechtliche Informationen');
      
      setLoading(false);
    } catch (error) {
      console.error('Error loading legal page:', error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black">
      {/* Header */}
      <header className="border-b border-yellow-600/20 bg-black/40 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/')}>
            <img src="/assets/smartvolt-logo.png" alt="Smartvolt Academy" className="h-12" />
          </div>
          <div className="flex items-center gap-4">
            <Button 
              variant="ghost" 
              className="text-gray-300 hover:text-yellow-500 hover:bg-yellow-500/10"
              onClick={() => navigate('/')}
            >
              <ArrowLeft className="h-4 w-4 mr-2" /> Zurück zur Startseite
            </Button>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        {loading ? (
          <div className="text-center py-20">
            <p className="text-white text-xl">Laden...</p>
          </div>
        ) : (
          <div className="bg-gray-900/50 border border-yellow-600/20 rounded-xl p-8">
            <div 
              className="prose prose-invert max-w-none
                prose-headings:text-yellow-500 
                prose-h1:text-3xl prose-h1:font-bold prose-h1:mb-6
                prose-h2:text-xl prose-h2:font-semibold prose-h2:mt-8 prose-h2:mb-4 prose-h2:text-yellow-400
                prose-h3:text-lg prose-h3:font-medium prose-h3:mt-6 prose-h3:mb-3 prose-h3:text-yellow-300
                prose-p:text-yellow-100 prose-p:leading-relaxed
                prose-a:text-yellow-500 prose-a:hover:text-yellow-400
                prose-strong:text-yellow-500
                prose-ul:text-yellow-100 prose-li:text-yellow-100
                prose-ol:text-yellow-100
                prose-td:text-yellow-100 prose-th:text-yellow-400
                [&>*]:text-yellow-100"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        )}

        {/* Footer Links */}
        <div className="mt-8 pt-8 border-t border-yellow-600/20 flex justify-center gap-8 text-sm">
          <Link to="/legal/impressum" className={`hover:text-yellow-500 ${pageType === 'impressum' ? 'text-yellow-500' : 'text-gray-400'}`}>
            Impressum
          </Link>
          <Link to="/legal/agb" className={`hover:text-yellow-500 ${pageType === 'agb' ? 'text-yellow-500' : 'text-gray-400'}`}>
            AGB
          </Link>
          <Link to="/legal/datenschutz" className={`hover:text-yellow-500 ${pageType === 'datenschutz' ? 'text-yellow-500' : 'text-gray-400'}`}>
            Datenschutz
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
